<template>
  <div class="countdown-bar-wrapper">
    <div v-if="remainingMs > 0" class="soft-blink">
      {{ $t('wingo.Place your bets') }}
    </div>

    <div class="progress-container">
      <div
        class="progress-bar"
        :style="{ width: progress + '%' }"
      ></div>
    </div>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  deadline: {
    type: String,
    required: true
  },
  maxTime: {
    type: Number,
    required: true // saniye
  }
})

const now = ref(Date.now())
let rafId = null

const tick = () => {
  now.value = Date.now()          // 🔥 REACTIVE TETİK
  rafId = requestAnimationFrame(tick)
}

onMounted(() => {
  tick()
})

onUnmounted(() => {
  if (rafId) cancelAnimationFrame(rafId)
})

const remainingMs = computed(() => {
  if (!props.deadline) return 0
  return Math.max(
    new Date(props.deadline).getTime() - now.value,
    0
  )
})

const progress = computed(() => {
  const totalMs = props.maxTime * 1000
  if (totalMs <= 0) return 0
  return Math.min(
    100,
    (remainingMs.value / totalMs) * 100
  )
})
</script>



<style scoped>
.countdown-bar-wrapper {
  text-align: center;
  user-select: none;
}

.soft-blink {
  font-size: 13px;
  color: #fff;
  font-weight: 400;
  opacity: 0.85;
  animation: soft-blink 1.4s ease-in-out infinite;
  margin-bottom: 0.5rem;
  text-align: left;
  padding-left: 6px;
}

@keyframes soft-blink {
  0%, 100% {
    opacity: 0.85;
  }
  50% {
    opacity: 0.4;
  }
}

.progress-container {
  height: 12px;
  width: 100%;
  background: var(--bar-outer);
  border-radius: 6px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: var(--bar-inner);
  border-radius: 6px;
  transition: width 0s linear;
  will-change: width;
}
</style>
